import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { hash } from 'rsvp';

export default class AuthenticatedPlaylistsNewRoute extends BaseRoute {
  @service store;
  @service currentUser;

  model() {
    let playlist = this.store.createRecord('playlist', {});

    let teams = this.store.query('team', {
      filter: {},
      include: '',
    });

    let projects = this.store.query('project', {
      filter: { archived: false },
      sort: '-latestVersionUpdatedAt',
      include: 'current-bounce',
    });

    let model = { playlist, teams, projects };
    console.log('model ==============', model);
    return hash(model);
  }
}
